// Redux action types
///rc-call-start-notify
export const RINGCENTRAL_CALLSTART = 'one-state-ring-central/call-start';
///rc-call-ring-notify
export const RINGCENTRAL_RING = 'one-state-ring-central/ring-';
//rc-call-hold-notify
export const RINGCENTRAL_CALLHOLD = 'one-state-ring-central/call-hold';
//rc-call-resume-notify
export const RINGCENTRAL_CALLRESUME = 'one-state-ring-central/call-resume';
//rc-call-end-notify
export const RINGCENTRAL_CALLEND = 'one-state-ring-central/call-end';

//rc-call-ring-notify
export const RINGCENTRAL_CALLRING = 'one-state-ring-central/call-ring';